import { RouteConfig } from 'vue-router';

const routes: RouteConfig[] = [
  {
    path: 'home',
    component: () => import('../ui/views/customer/Home.vue'),
  },
];

export default routes;
